import { styled } from '../../styles';

export const PopperWrapper = styled('div')(() => {
  return {
    position: 'relative',
  };
});
